var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgNotAvailable = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 270,
  height: 181,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#not-available_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M136.041 2.076a37.698 37.698 0 0 1 37.695 37.238l.002.46.26 30.332a5.933 5.933 0 0 1-1.703 4.24 5.92 5.92 0 0 1-4.216 1.765 6.06 6.06 0 0 1-6.062-6.005l-.168-30.331c0-14.111-11.324-25.577-25.381-25.805l-.427-.003c-14.111 0-25.577 11.324-25.805 25.38l-.004.428-.032 49.379H98.266l.075-49.38c0-20.82 16.88-37.698 37.701-37.698h-.001Z",
  fill: "url(#not-available_svg__b)"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.17,
  d: "m174.003 70.106-.258-30.331a25.778 25.778 0 0 0-9.787-20.257 25.764 25.764 0 0 0-21.968-4.845 25.838 25.838 0 0 1 19.864 25.1l.168 30.331a6.059 6.059 0 0 0 6.062 6.005 5.918 5.918 0 0 0 5.919-6.005v.002Z",
  fill: "url(#not-available_svg__c)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M126.402 128.834h17.25v27.024h-17.25v-27.024Z",
  fill: "#FF4244"
}), /*#__PURE__*/React.createElement("path", {
  d: "M183.097 115.742h-78.835v-44.11a6.168 6.168 0 0 1 6.154-6.155h66.465a6.173 6.173 0 0 1 6.216 6.155v44.11Z",
  fill: "url(#not-available_svg__d)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M143.654 155.858c21.758 0 39.395-17.638 39.395-39.395 0-21.758-17.637-39.395-39.395-39.395-21.757 0-39.395 17.637-39.395 39.395 0 21.757 17.638 39.395 39.395 39.395Z",
  fill: "url(#not-available_svg__e)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M165.782 115.742H87.007v-44.11a6.17 6.17 0 0 1 6.156-6.155h66.464a6.154 6.154 0 0 1 6.155 6.155v44.11Z",
  fill: "url(#not-available_svg__f)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M126.402 155.137c21.758 0 39.395-17.638 39.395-39.395s-17.637-39.395-39.395-39.395c-21.757 0-39.395 17.638-39.395 39.395s17.638 39.395 39.395 39.395Z",
  fill: "url(#not-available_svg__g)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M159.627 65.477H93.165a6.171 6.171 0 0 0-6.158 6.155v44.11a39.396 39.396 0 1 0 78.776 0v-44.11a6.158 6.158 0 0 0-6.156-6.155Zm-4.039 50.265a29.195 29.195 0 0 1-8.313 21.073 29.207 29.207 0 0 1-20.88 8.787 29.203 29.203 0 0 1-27.163-18.484 29.202 29.202 0 0 1-2.03-11.376v-40.07h58.386v40.07Z",
  fill: "url(#not-available_svg__h)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m131.056 110.713 1.741 6.636a2.729 2.729 0 0 1-.476 2.35 2.721 2.721 0 0 1-2.152 1.057h-7.506a2.72 2.72 0 0 1-2.151-1.057 2.716 2.716 0 0 1-.476-2.35l1.741-6.636a8.712 8.712 0 0 1-3.123-3.544 8.453 8.453 0 0 1-.841-3.707 8.63 8.63 0 0 1 5.239-8.3 8.63 8.63 0 0 1 11.46 4.888 8.63 8.63 0 0 1 .551 3.412 8.76 8.76 0 0 1-.825 3.707 8.642 8.642 0 0 1-3.182 3.544Z",
  fill: "#353535"
}), /*#__PURE__*/React.createElement("path", {
  d: "m132.8 117.349-1.741-6.636a8.63 8.63 0 0 0 3.926-8.056 8.638 8.638 0 0 0-5.337-7.198 8.624 8.624 0 0 0-5.355 7.197 8.623 8.623 0 0 0 3.943 8.057l-1.741 6.636a2.719 2.719 0 0 0 2.626 3.407h1.052c.415 0 .826-.095 1.199-.278a2.724 2.724 0 0 0 1.463-1.899 2.705 2.705 0 0 0-.035-1.23Z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.085,
  d: "M134.424 180.54c19.988 0 36.192-1.956 36.192-4.368 0-2.413-16.204-4.368-36.192-4.368s-36.192 1.955-36.192 4.368c0 2.412 16.204 4.368 36.192 4.368Z",
  fill: "#2A2A2A"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "not-available_svg__b",
  x1: 98.266,
  y1: 45.615,
  x2: 173.998,
  y2: 45.615,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF4244"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF8E3C"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "not-available_svg__c",
  x1: 156.508,
  y1: 16.697,
  x2: 180.461,
  y2: 73.028,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#646478"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#78788C"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "not-available_svg__d",
  x1: 144.677,
  y1: 116.256,
  x2: 144.11,
  y2: 82.96,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF4244"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF8E3C"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "not-available_svg__e",
  x1: 144.3,
  y1: 154.432,
  x2: 142.904,
  y2: 72.548,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF4244"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF8E3C"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "not-available_svg__f",
  x1: 87.007,
  y1: 90.609,
  x2: 165.782,
  y2: 90.609,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#646478"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#78788C"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "not-available_svg__g",
  x1: 87.007,
  y1: 115.742,
  x2: 165.782,
  y2: 115.742,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#646478"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#78788C"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "not-available_svg__h",
  x1: 151.578,
  y1: 123.608,
  x2: 79.623,
  y2: 78.719,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF4244"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF8E3C"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "not-available_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(0 .076)",
  d: "M0 0h270v180H0z"
})))));
export default SvgNotAvailable;